// Import from NPM
// -------------------------------------
import _ from "lodash";
import { REHYDRATE } from "redux-persist/constants";

// Import from Config
// -------------------------------------
import { SET_USER_OPTIONS } from "./CreatorConfig.action.react";

const initialUserOptionsState = {
    userName: "",
    currentFile: "",
    preferredView: "mobile",
    googleAPIKey: "",
    uploadURL: "",
    slideShow: false,
    recentFiles: []
};

const CreatorConfigReducer = (state = initialUserOptionsState, action) => {
    switch (action.type) {
        /* istanbul ignore next - redux-persist function */
        case REHYDRATE:
            let config = action.payload.config;
            if (config) {
                return {
                    ...state,
                    ...config
                };
            } else {
                return state;
            }

        case SET_USER_OPTIONS:
            return _.assign({}, state, action.data);
        default:
            return state;
    }
};

export { CreatorConfigReducer };
